import { FaTripadvisor } from 'react-icons/fa';
import GoogleRating from '../GoogleRating';
import { FcGoogle } from 'react-icons/fc';

const GenerateBadge = ({ badgeData }) => {
  if (Object?.keys(badgeData)?.length === 0) return null;
  return (
    <idk-div class="zid-flex zid-flex-col zid-gap-3">
      <idk-div class="zid-flex zid-items-center zid-font-bold zid-gap-2">
        {badgeData?.source === 'Google_Review' ? (
          <FcGoogle className="zid-h-8 zid-w-8" />
        ) : (
          <idk-div class="zid-flex zid-justify-center zid-items-center zid-gap-2 zid-h-8 zid-w-8 zid-bg-[#35e0a1] zid-rounded-full">
            <FaTripadvisor className="zid-text-lg" />
          </idk-div>
        )}
        <a href={badgeData?.reviewUrl} target="_blank" className="zid-text-inherit">
          {badgeData?.source === 'Google_Review' ? 'Google ' : 'TripAdvisor '} Reviews
        </a>
      </idk-div>
      <idk-div class="zid-flex zid-gap-2 zid-items-center">
        <idk-p class="zid-text-lg zid-font-extrabold">{badgeData?.rating}</idk-p>
        <GoogleRating rating={badgeData?.rating} />
        <idk-span class="zid-text-xs zid-text-[#11111180] ">({badgeData?.totalReview?.toLocaleString()})</idk-span>
      </idk-div>
    </idk-div>
  );
};

export default function ReviewHeader(props) {
  const { data, layout } = props;
  return (
    <idk-div class="zid-p-6 zid-bg-[#1111110d] zid-rounded zid-flex zid-justify-between zid-items-center zid-flex-wrap zid-gap-3 idk-badge-container">
      <idk-div class="zid-flex zid-gap-4 zid-flex-wrap">
        {data?.result?.metaJson?.length > 0 &&
          data?.result?.metaJson?.map((item, index) => <GenerateBadge key={index} badgeData={item} />)}
      </idk-div>
      {layout?.googleSummaryOptions?.showButton && (
        <idk-div
          class="zid-flex"
          // style={{ justifyContent: layout?.googleSummaryOptions?.buttonAlignment, fontSize: '14px' }}
        >
          {layout?.googleSummaryOptions?.reviewBtnContent ? (
            <idk-div dangerouslySetInnerHTML={{ __html: layout?.googleSummaryOptions?.reviewBtnContent }}></idk-div>
          ) : (
            <>
              {layout?.googleSummaryOptions?.showCtaAsLink ? (
                <a
                  href={layout?.googleSummaryOptions?.buttonUrl}
                  style={{ textDecoration: 'underline', color: 'blue' }}
                >
                  {layout?.googleSummaryOptions?.buttonText}
                </a>
              ) : (
                <>
                  <idk-div
                    class="idk-review-btn"
                    style={{
                      border: '1px solid',
                      borderRadius: '4px',
                      padding: '4px 10px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      cursor: 'pointer',
                      color: layout?.googleSummaryOptions?.buttonTextColor,
                      backgroundColor: layout?.googleSummaryOptions?.buttonColor
                        ? layout?.googleSummaryOptions?.buttonColor
                        : 'transparent',
                      borderColor: layout?.googleSummaryOptions?.buttonTextColor,
                      width: 'auto',
                    }}
                    onClick={() => {
                      /*window.open(
                    `https://search.google.com/local/writereview?placeid=${data?.result?.metaJson?.[0]?.details?.[0]?.place_id}`,
                    '_blank',
                  );*/
                      window.open(layout?.googleSummaryOptions?.buttonUrl, '_blank');
                    }}
                  >
                    {layout?.googleSummaryOptions?.buttonText}
                  </idk-div>
                  <idk-div />
                </>
              )}
            </>
          )}
        </idk-div>
      )}
    </idk-div>
  );
}
